module.exports = __webpack_public_path__ + "static/green-circle-c4af573f1c05cde46065236219af64b9.png";